interface Model<T = number> {
  id: T;
  createdDate: Date;
  updatedDate: Date;
}

export enum LocationType {
  WorkPlace = 'workPlace',
  AccreditedNetwork = 'accreditedNetwork',
  Refund = 'refund'
}

export enum TransportType {
  PublicTransportation = 'publicTransportation',
  OwnVehicle = 'ownVehicle',
  AppOrTaxi = 'appOrTaxi'
}

export enum VaccinationStatusType {
  Rejected = 'rejected',
  Accepted = 'accepted',
  Canceled = 'canceled',
  Attended = 'attended',
  Scheduled = 'scheduled'
}

export const VaccinationStatusTypeColor = {
  [VaccinationStatusType.Canceled]: '#DB0032',
  [VaccinationStatusType.Rejected]: '#DB0032',
  [VaccinationStatusType.Attended]: '#A2D45E',
  [VaccinationStatusType.Scheduled]: '#FED925',
  [VaccinationStatusType.Accepted]: '#E50695'
};

export const VaccinationStatusTypeText = {
  [VaccinationStatusType.Canceled]: 'Cancelado',
  [VaccinationStatusType.Rejected]: 'Rejeitado',
  [VaccinationStatusType.Attended]: 'Atendido',
  [VaccinationStatusType.Scheduled]: 'Agendado',
  [VaccinationStatusType.Accepted]: 'Aceito'
};

export interface VaccinationCampaign extends Model {
  description: string;
  startDate: Date;
  endDate: Date;
}

export interface WorkPlace extends Model {
  city: string;
  description: string;
}

export interface VaccinationInfo extends Model {
  status: VaccinationStatusType;
  scheduledDate?: string;
  locationType: LocationType;
  transportType?: TransportType;
  vehicleId?: string;
  vaccinationCampaignId?: number;
  vaccinationPointId?: number;
  workplaceId: number;
  userId: number;
  vaccinationCampaign: VaccinationCampaign;
  workplace: WorkPlace;
  user: User;
}

export interface User extends Model {
  firstName: string;
  lastName: string;
  email: string;
  password: string;
  deskRoles: null;
  roles: string;
  workplaceId: number;
  workSectorId: number;
  companyId: number;
  vicePresidencyId: number;
  gpId: string;
  employmentStatus: string;
  profilePhoto?: string;
  phone1?: string;
  phone2?: string;
  fullName: string;
}
